import * as React from "react";

import { Popover } from "antd";
import { cx } from "class-variance-authority";

import { Button } from "../Button";

import * as styles from "./DisabledLink.css";

interface DisabledLinkProps {
    /**
     * The component content.
     */
    children: React.ReactNode;
    /**
     * Any class name to add to the component.
     */
    className?: string;
    /**
     * An explanation for why the link is disabled.
     */
    reason: string;
}

function DisabledLink({ children, reason, className }: DisabledLinkProps) {
    return (
        <Popover content={reason}>
            <Button
                variant="link"
                size="nosize"
                className={cx(styles.disabledLinkButton, className)}
            >
                {children}
            </Button>
        </Popover>
    );
}

export { DisabledLink };
export type { DisabledLinkProps };
